module.exports = __webpack_public_path__ + "static/media/Private-Client-and-Notary-Service.ffd264b7.jpg";